import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "camera-status-brief__content" }
const _hoisted_2 = {
  key: 0,
  class: "label-xs camera-status-brief__content_description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _renderSlot(_ctx.$slots, "default", {}, () => [
    _createElementVNode("div", {
      class: _normalizeClass(['camera-status-brief', `camera-status-brief_type-${_ctx.type}`])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, _toDisplayString(_ctx.status), 1),
        (_ctx.type === 'circle')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.description), 1))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ])
}